import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../styles/RestaurantList.css";

const RestaurantList = () => {
  const [restaurants, setRestaurants] = useState([]);
  const [error, setError] = useState(null);

  const isLocalhost =
    window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
  const basePath = isLocalhost
    ? ""
    : "https://webdev.cse.buffalo.edu/hci/teams/indecisive";

  useEffect(() => {
    const dataUrl = isLocalhost
      ? "/data/restaurants.json"
      : `${basePath}/data/restaurants.json`;

    fetch(dataUrl)
      .then((res) => res.json())
      .then((data) => {
        const enriched = data.restaurants.map((r) => ({
          ...r,
          logo: r.logo?.startsWith("http") || r.logo?.startsWith("data:")
            ? r.logo
            : `${basePath}${r.logo}`,
        }));

        const sorted = enriched.sort((a, b) => a.name.localeCompare(b.name));
        setRestaurants(sorted);
      })
      .catch((err) => {
        console.error("Failed to fetch restaurants:", err);
        setError("Unable to load restaurant list.");
      });
  }, []);

  if (error) return <div>{error}</div>;

  return (
    <div className="restaurant-list-container">
      <h1>Restaurants</h1>
      <ul style={{ listStyleType: "none", padding: 0 }}>
        {restaurants.map((restaurant) => (
          <Link to={`/restaurant/${restaurant.id}`} key={restaurant.id}>
            <li>
              {restaurant.logo && (
                <img
                  src={restaurant.logo}
                  alt={`${restaurant.name} logo`}
                  style={{
                    width: "80px",
                    height: "80px",
                    objectFit: "cover",
                    borderRadius: "8px",
                    marginBottom: "0.5rem",
                  }}
                />
              )}
              <p>{restaurant.name}</p>
            </li>
          </Link>
        ))}
      </ul>
    </div>
  );
};

export default RestaurantList;
